import React, {useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {LoadingButton} from '@mui/lab';
import {StyleSx} from 'app/types/common';
import {useMounted} from 'app/hooks/useIsMounted';
import {DangerouslyHTML} from 'app/components/sharedReactComponents/DangerouslyHTML';

const contentSx: StyleSx = {maxHeight: '50vh', overflow: 'auto', px: 3, py: 1};

interface Props {
  open: boolean;
  content: string;
  onAccept: () => Promise<void>;
}

export function AgreementDialog({open, content, onAccept}: Props) {
  const [loading, setLoading] = useState(false);

  const mounted = useMounted();

  const handleAccept = async () => {
    setLoading(true);

    await onAccept();

    if (mounted()) {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth={true}>
      <DialogTitle variant="h4">Epiphan Terms of Service</DialogTitle>

      <DialogContent>
        <DangerouslyHTML sx={contentSx} content={content} />
      </DialogContent>

      <DialogActions>
        <LoadingButton
          variant="contained"
          color="secondary"
          loading={loading}
          onClick={handleAccept}
        >
          Accept
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
